import { ArrowRightIcon } from "lucide-react";

import type { CanonicalAddress } from "@tycho/web-bindings/types";
import { CompMap } from "./CompMap";
import { ReviewActionButton, ReviewStepFrame, ReviewStepHeading } from "./ReviewStepUi";
import type { ReviewComp } from "./types";

export function IntroReview({
  comps,
  targetAddress,
  propertyAddress,
  onStart,
}: {
  comps: ReviewComp[];
  targetAddress: string;
  propertyAddress: CanonicalAddress;
  onStart: () => void;
}) {
  return (
    <ReviewStepFrame
      footer={
        <ReviewActionButton
          onClick={onStart}
          label="Get started"
          icon={<ArrowRightIcon className="size-4" />}
          disabled={comps.length === 0}
        />
      }
    >
      <ReviewStepHeading
        title={
          comps.length > 0
            ? `We’ve created a list of ${comps.length} comparable properties`
            : "We’re still fetching comparable properties"
        }
        description={
          <div className="space-y-4">
            <p>
              Please review and let us know which of these properties are similar to{" "}
              <strong>{targetAddress}.</strong>
            </p>
            <p>
              Note that the properties shown are <strong>not necessarily available</strong> for sale
              or lease.
            </p>
          </div>
        }
      />
      <CompMap targetAddress={propertyAddress} comps={comps} />
    </ReviewStepFrame>
  );
}
